import React, { useState } from 'react';
import {
  Box,
  Container,
  Fade,
  Grid,
  ListItem,
  makeStyles,
  Modal,
  Paper,
  Typography,
} from '@material-ui/core';

import GetAppIcon from '@material-ui/icons/GetApp';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import Backdrop from '@material-ui/core/Backdrop';
import { UtilsDate } from '../../../app/orussystem/utils/UtilDate';

const useStyles = makeStyles((theme) => ({
  seeMore: {
    marginTop: theme.spacing(3),
  },
  box: {
    display: "flex",
  },
  spreadBox: {
    justifyContent: "space-between",
    alignItems: "center"
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  fixedHeight: {
    height: 320,
  },
  tableAction: {
    paddingLeft: 0,
    paddingRight: 0,
    margin: "0 auto",
    textAlign: "center",
    alignItems: "center"
  },
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '600px',
    margin: 'auto'

  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    borderRadius: '10px'
  },
  paperContent: {
    backgroundColor: process.env.REACT_APP_PRIMARY_THEMA,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(1, 1, 1),
    borderRadius: '10px'
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },
  card: {
    padding: theme.spacing(3),
    marginBottom: theme.spacing(2),
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
    borderRadius: '10px',
    height: '80px',
    marginTop: '-3%',
    marginBottom: '3.2%'
  },
  cardContent: {
    display: 'flex',
    flexDirection: 'column',
  },
  cardActions: {
    display: 'flex',
    justifyContent: 'space-between',
  },
}));

export default function DatosTablaMantenimiento({ data, nameBascula, primaryColor }) {
  const classes = useStyles()
  const [open, setOpen] = useState(false);
  const [detalle, setDetalle] = useState("");
  const [evidencia, setEvidencia] = useState("");
  const [encargado, setEncargado] = useState("");
  const [tipoActividad, setTipoActividad] = useState("");
  const [responsable, setResponsable] = useState("");
  const [documento, setDocumento] = useState("");
  const [cargo, setCargo] = useState("");
  const [celular, setCelular] = useState("");
  const [fecha, setFecha] = useState("");

  const handleOnClick = (file) => {
    window.open('https://s3.amazonaws.com/' + process.env.REACT_APP_AWS_BUCKET + `/MANTENIMIENTOS_BASCULAS/${nameBascula.replace(/\s+/g, "_")}/${file}`)
  };


  const handleOpen = (row) => {

    setDetalle(row.detalle)
    setEvidencia(row.evidencia)
    setEncargado(row.encargado)
    setTipoActividad(row.actividad)
    setResponsable(row.responsable)
    setDocumento(row.documento_responsable)
    setCargo(row.cargo_responsable)
    setCelular(row.celular_responsable)
    setFecha(row.created);
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const bull = <span className={classes.bullet}>•</span>;
  const r = data !== undefined && data !== null ? data : []
  if (!data || data.length === 0) {
    return (
      <Paper className={classes.card}>
        <Typography variant="h6">No hay mantenimientos disponibles</Typography>
      </Paper>
    );
  }

  return (
    <>
      {data.map((row) => (
        <Paper key={row.id} className={classes.card}>
          <Grid container spacing={1}>
            <Grid style={{ width: '14%', fontWeight: 'bold', fontSize: '16px' }}>
              {UtilsDate().formatDDMMMYYYYHHmm(new Date(row.updated ? row.updated : '--'))}
            </Grid>
            <Grid style={{ width: '16.5%', fontWeight: 'bold', fontSize: '16px',paddingLeft:'2%' }}>
              {row.encargado ? row.encargado : '--'}
            </Grid>
            <Grid style={{ width: '20%', fontWeight: 'bold', fontSize: '16px',paddingLeft:'1%' }}>
              {row.actividad ? row.actividad : '--'}
            </Grid>
            <Grid style={{ width: '19%', fontWeight: 'bold', fontSize: '16px',paddingLeft:'2%' }}>
              {row.responsable ? row.responsable : '--'}
            </Grid>
            <Grid item xs={1}>
  <ListItem 
    button
    onClick={() => {
      if (row.evidencia) {
        handleOnClick(row.evidencia);
      }
    }}
    disabled={!row.evidencia}
  >
    <GetAppIcon style={{ color: primaryColor, marginLeft: '12px' }} />
  </ListItem>
</Grid>
            <Grid item xs={1}style={{marginLeft:'7%'}}>
              <ListItem
                button
                onClick={() => {
                  handleOpen(row);
                }}
              >
                <AddCircleOutlineIcon style={{ color: primaryColor,marginLeft:'20px' }} />
              </ListItem>
            </Grid>
          </Grid>
        </Paper>
      ))}

      <Modal
        className={classes.modal}
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <div className={classes.paperContent}>
            <Container style={{ backgroundColor: '#ffffff', borderRadius: '10px', padding: '2rem' }}>
              <Box component="span" m={1} className={`${classes.spreadBox} ${classes.box}`}>
                <Typography style={{ color: primaryColor,fontSize:'20px' }}>Detalle - Mantenimiento {UtilsDate().formatDDMMMYYYYHHmm(new Date(fecha))}</Typography>
              </Box>
              <Box component="fieldset" border={1} borderRadius={8} borderColor="grey.500" p={2}  >
                <Typography variant="h6" component="h2">{bull}Responsable</Typography>
                <Grid container spacing={2} style={{ marginTop: '5px' }}>
                  <Grid item xs={12}>
                    <Typography variant="body2" component="p" style={{ textAlign: 'justify' }}>
                      <strong style={{ fontSize: "16px" }}>Actividad Realizada:</strong>
                      <span style={{ whiteSpace: "pre-line", fontSize: "17px", marginLeft: "10px" }}>
                        {detalle}
                      </span>
                    </Typography>
                  </Grid>
                </Grid>
                <Grid container spacing={2} style={{ marginTop: '1px' }}>
                  <Grid item xs={12}>
                    <Typography variant="body2" component="p" style={{ textAlign: 'justify' }}>
                      <strong style={{ fontSize: "16px" }}>Encargado:</strong>
                      <span style={{ whiteSpace: "pre-line", fontSize: "17px", marginLeft: "10px" }}>
                        {encargado}
                      </span>
                    </Typography>
                  </Grid>
                </Grid>
                <Grid container spacing={2} style={{ marginTop: '1px' }}>
                  <Grid item xs={12}>
                    <Typography variant="body2" component="p" style={{ textAlign: 'justify' }}>
                      <strong style={{ fontSize: "16px" }}>Tipo de Actividad:</strong>
                      <span style={{ whiteSpace: "pre-line", fontSize: "17px", marginLeft: "10px" }}>
                        {tipoActividad}
                      </span>
                    </Typography>
                  </Grid>
                </Grid>
              </Box>
              <Box component="fieldset" border={1} borderRadius={8} borderColor="grey.500" p={2} style={{ marginTop: '1rem' }} >
                <Typography variant="h6" component="h2">{bull}Recibe</Typography>
                <Grid container spacing={2} style={{ marginTop: '1px' }}>
                  <Grid item xs={12}>
                    <Typography variant="body2" component="p" style={{ textAlign: 'justify' }}>
                      <strong style={{ fontSize: "16px" }}>Responsable:</strong>
                      <span style={{ whiteSpace: "pre-line", fontSize: "17px", marginLeft: "10px" }}>
                        {responsable}
                      </span>
                    </Typography>
                  </Grid>
                </Grid>
                <Grid container spacing={2} style={{ marginTop: '1px' }}>
                  <Grid item xs={12}>
                    <Typography variant="body2" component="p" style={{ textAlign: 'justify' }}>
                      <strong style={{ fontSize: "16px" }}>Documento:</strong>
                      <span style={{ whiteSpace: "pre-line", fontSize: "17px", marginLeft: "10px" }}>
                        {documento}
                      </span>
                    </Typography>
                  </Grid>
                </Grid>
                <Grid container spacing={2} style={{ marginTop: '1px' }}>
                  <Grid item xs={12}>
                    <Typography variant="body2" component="p" style={{ textAlign: 'justify' }}>
                      <strong style={{ fontSize: "16px" }}>Cargo:</strong>
                      <span style={{ whiteSpace: "pre-line", fontSize: "17px", marginLeft: "10px" }}>
                        {cargo}
                      </span>
                    </Typography>
                  </Grid>
                </Grid>
                <Grid container spacing={2} style={{ marginTop: '1px' }}>
                  <Grid item xs={12}>
                    <Typography variant="body2" component="p" style={{ textAlign: 'justify' }}>
                      <strong style={{ fontSize: "16px" }}>Celular:</strong>
                      <span style={{ whiteSpace: "pre-line", fontSize: "17px", marginLeft: "10px" }}>
                        {celular}
                      </span>
                    </Typography>
                  </Grid>
                </Grid>
              </Box>
            </Container>
          </div>
        </Fade>
      </Modal>
    </>
  );
}
